export default {
  recommendations: state => state.recommendations,
  recommendation: state => state.recommendation,
  step: state => state.step,
  visitedStep: state => state.visitedStep,
  translations: state => state.translations,
  bmsRepairs: state => state.bmsRepairs,
  bmsXml: state => state.bmsXml
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/getters.js